<template lang="html">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3 d-sm-none d-md-block d-xs-none sidebar">
        <div>
        </div>
      </div>
      <div class="col-md-9 col-sm-12 text-left">
        <SmallHeader/>
        <div class="support">
          <div v-if="loader" class="loader"></div>
          <h3><a @click="$router.go(-1)"><img class="img-responsive" src="../../assets/img/icons/back-button.svg" alt="Back Button"></a>{{translation.contact.title}}</h3>
          <div class="row">
            <div class="col-sm-12 support-margin">
              <p>{{translation.contact.firm}}</p>
              <p>{{translation.contact.address}}</p>
              <p>{{translation.contact.phone}}</p>
              <p>{{translation.contact.email}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 support-margin">
              <p>{{translation.contact.form}}</p>
            </div>
          </div>
            <p class="text-left required">
              <span>{{translation.registration.requiredField}}</span>
              <span>{{translation.registration.requiredSymbol}}</span>
              <span>{{translation.registration.areRequired}}</span>
            </p>
            <p v-if="errors.length" class="text-left text-required required">
              <b>{{translation.registration.correct}}:</b>
              <ul class="list-group">
                <li class="text-required text-left list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
              </ul>
            </p>
            <p v-if="send" class="text-left text-send required">
              <b>{{translation.contact.sendEmail}}</b>
            </p>
            <form @submit.prevent="contactForm" novalidate>
              <div class="row">
                <div class="form-group col-md-6">
                  <div :class="{ requiredField: requiredEmail }">
                    <input type="email" name="contact-email" v-model="contact.email" :placeholder="translation.registration.email + translation.registration.requiredSymbol">
                    <label for="contact-email">
                      <span>{{translation.registration.email}}</span>
                      <span>{{translation.registration.requiredSymbol}}</span>
                    </label>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div :class="{ requiredField: requiredTheme }">
                    <input type="text" name="contact-theme" v-model="contact.theme" :placeholder="translation.contact.theme + translation.registration.requiredSymbol">
                    <label for="contact-theme">
                      <span>{{translation.contact.theme}}</span>
                      <span>{{translation.registration.requiredSymbol}}</span>
                    </label>
                  </div>
                </div>
                <div class="form-group textarea-container col-md-12">
                  <div :class="{ requiredField: requiredComment }">
                    <textarea name="comment" rows="1" v-model="contact.comment" :placeholder="translation.petReview.comment +translation.registration.requiredSymbol">
                    </textarea>
                    <label for="comment">
                      <span>{{translation.petReview.comment}}</span>
                      <span>{{translation.registration.requiredSymbol}}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 text-right">
                <b-button type="submit" size="sm" class="float-right contact-send"><span><img class="img-responsive" src="../../assets/img/icons/arrow-send.svg" alt="Send Button"></span><span class="contact-send-text">{{translation.button.submit}}</span></b-button>
              </div>
          </form>
          <Footer/>
        </div>
        <div class="grey-paw">
          <img class="img-responsive" src="../../assets/img/icons/grey-paws.svg" alt="Paw">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SmallHeader from '../../components/SmallHeader.vue'
import Footer from '../../components/Footer.vue'
export default {
  data(){
    return {
      translation: null,
      errors:[],
      loader: false,
      send: false,
      requiredEmail: false,
      requiredTheme: false,
      requiredComment: false,
      contact:{
        email: '',
        theme: '',
        comment: ''
      }
    }
  },
  components: {
    SmallHeader,
    Footer
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    if (localStorage.getItem('userLoggedIn') != undefined || localStorage.getItem('doctorLoggedIn') !=undefined) {
        if (localStorage.getItem('userLoggedIn')) {
          this.getUser();
        }else if (localStorage.getItem('doctorLoggedIn')) {
          this.getDoctor();
        }
      }
    },
    methods: {
      validate: function (e) {
        this.errors = [];
        if (!this.contact.email) {
          this.errors.push(
            this.translation.registration.field + ' "' +
            this.translation.registration.email + '" ' +
            this.translation.registration.required
          );
          this.requiredEmail = true;
        } else if (!this.validEmail(this.contact.email)) {
          this.errors.push(this.translation.registration.validEmail);
          this.requiredEmail = true;
        }
        if (!this.contact.theme) {
          this.errors.push(
            this.translation.registration.field + ' "' +
            this.translation.contact.theme + '" ' +
            this.translation.registration.required
          );
          this.requiredTheme = true;
        }
        if (!this.contact.comment) {
          this.errors.push(
            this.translation.registration.field + ' "' +
            this.translation.petReview.comment + '" ' +
            this.translation.registration.required
          );
          this.requiredComment = true;
        }

        if (!this.errors.length) {
          return true;
        }
      },
      validEmail: function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      contactForm: function (e){
        if (this.validate(e)) {
          this.loader = true;
          var formData = this.toFormData(this.contact);
          var self = this;
          axios.post('conatcts', formData)
          .then(function(response){
            self.loader = false;
            self.send = true;
            self.contact.email = '';
            self.contact.theme = '';
            self.contact.comment = '';
          })
          .catch(err => err)
        }
      },
      getUser: function(){
        this.loader = true;
        var self = this;
        axios.get('get-user')
        .then(function (response){
          self.loader = false;
          self.contact.email = response.data.result.email;
        })
        .catch(err => console.error(err))
      },
      getDoctor: function(){
        this.loader = true;
        var self = this;
        axios.get('get-doctor')
        .then(function (response){
            self.loader = false;
            self.contact.email = response.data.result.doctorEmail;
        })
        .catch(err => console.error(err))
      },
      toFormData: function (obj){
        var form_data = new FormData();
        for (var key in obj) {
          form_data.append(key,obj[key]);
        }
        return form_data;
      }
    }
  }
</script>

<style>
.support {
  width: 70%;
  color: #fff;
  margin-top: 3em;
  margin-left: 3em;
}
#support-us{
  position: relative;
}
.support-margin{
  margin-top: 2em;
  margin-bottom: 2em;
}
.sidebar div {
  background-image: url('../../assets/img/backgrounds/Ozzy_sait.jpg');
}
.support form{
  margin-top: 2em;
}
.grey-paw{
  position: absolute;
  right: 0;
  top: 50%;
}
.text-required{
  color: #FDD84C;
}
.list-group-item{
  border: none;
  background: none;
  padding-left: 0;
}
.text-send {
  color: #fff;
}
.list-group-item{
  border: none;
  background: none;
  padding-left: 0;
  font-size: .8em;
}
#app input[type=email],#app input[type=text],
#app textarea{
  color: #fff;
}
#app textarea{
  margin-top: 2em;
}
#app label {
  display: none;
}
.textarea-container{
  position: relative;
}
.support input:focus + label,
.support textarea:focus + label{
   display: block!important;
   position: absolute!important;
   bottom: 2em!important;
   color: #EEEEEE!important;
   font-size: 1em!important;
   opacity: 1!important;
}
.support textarea:focus + label{
  bottom: -2em!important;
  left: 1em!important;
}
::placeholder {
  color: #EEEEEE;
  opacity: 1;
}
:-ms-input-placeholder {
  color: #EEEEEE;
}
::-ms-input-placeholder {
  color: #EEEEEE;
}
#app input:focus::-webkit-input-placeholder,
#app textarea:focus::-webkit-input-placeholder {
  color:transparent!important;
}
#app input:focus:-moz-placeholder,
#app textarea:focus:-moz-placeholder {
  color:transparent!important;
}
#app input:focus::-moz-placeholder,
#app textarea:focus::-moz-placeholder {
   color:transparent!important;
 }
#app input:focus:-ms-input-placeholder,
#app textarea:focus:-ms-input-placeholder {
  color:transparent!important;
}
#app input:-webkit-autofill,
#app input:-webkit-autofill:hover,
#app input:-webkit-autofill:focus{
    transition: background-color 5000s ease-in-out 0s;
}

.requiredField input,
.requiredField textarea{
  border-bottom: 2px solid #FDD84C!important;
  color: #FDD84C;
}
.support .contact-send:hover {
  color: #fff;
}
#app {
  background: linear-gradient(to bottom, #3057b0 0%, #4377c5 100%);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
  min-height: 100%;
  min-width: 100%;
}
.required{
  padding-left: 1em;
}
.contact-send{
  background: #FE7154;
  padding: .5em;
  border: none;
  outline: none;
  border-radius: 5em;
}
.contact-send:hover{
  background: #FE7154;
  border: none;
  outline: none;
}
.support .contact-send span img{
  padding-right: .5em;
  width: 1.8em;
}
.support .footer{
  margin-top: 22em;
}
@media (max-width: 768px) {
  .grey-paw{
    top: 5%;
    width: 4em;
  }
  .support {
    margin-top: 2em;
    width: 95%;
    margin-left: 0;
    margin: 0 auto;
  }

  .support .contact-send .contact-send-text{
    display: none;
  }
  .support .contact-send{
    padding: 1em;
  }
  .support .contact-send span img{
    padding-right: 0;
    width: 2em;
  }
  .support input:focus + label,
  .support textarea:focus + label{
     display: block!important;
     position: absolute!important;
     bottom: 4em!important;
     color: #EEEEEE!important;
     font-size: 1em!important;
     opacity: 1!important;
  }
 }
 @media (max-width: 600px) {
   .support{
     width: 91%;
     margin-top: 1em;
   }
 }
</style>
